'use client'

import { Icon } from '@/components/ui/icon'
import { NAV_TOPNAV } from '@/config/nav'
import { useCurrentUser } from '@/hooks/use-current-user'
import { cn } from '@/lib/utils'
import { Button, Popover, PopoverContent, PopoverTrigger } from '@heroui/react'
import { NavbarContent, NavbarItem } from '@/components/ui/navbar'
import { UserRole } from '@prisma/client'
import Link from 'next/link'
import { useState } from 'react'

export function TopNav() {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const user = useCurrentUser()
  const isAdmin = user?.role === UserRole.ADMIN

  return (
    <div className='flex flex-row gap-4 items-center'>
      {/* Desktop Navigation */}
      <NavbarContent className='hidden flex-1 gap-4 justify-center sm:flex text-foreground '>
        {NAV_TOPNAV.map((item) => (
          <NavbarItem key={item.label}>
            <Link href={item.href} title={item.title} className='flex flex-row gap-2 items-center'>
              <Icon icon={item.icon} className='w-4 h-4' /> {item.label}
            </Link>
          </NavbarItem>
        ))}
      </NavbarContent>

      {/* Admin Link - Only visible to admin users - Positioned at top right */}
      {isAdmin && (
        <NavbarContent className='hidden flex-1 gap-4 justify-center sm:flex text-foreground '>
          <NavbarItem>
            <Link href='/dashboard' className='flex flex-row gap-2 items-center'>
              <Icon icon='shield' className='w-4 h-4' />
              Admin
            </Link>
          </NavbarItem>
        </NavbarContent>
      )}

      {/* Mobile Navigation */}
      <NavbarContent className='flex z-10 flex-1 md:hidden'>
        <div className='flex gap-2 items-center'>
          {/* Mobile Menu Popover */}
          <Popover isOpen={isPopoverOpen} onOpenChange={(open) => setIsPopoverOpen(open)}>
            <PopoverTrigger>
              <Button
                variant='ghost'
                radius='full'
                size='sm'
                className='bg-content2 hover:bg-content1'
                aria-label='Toggle navigation menu'
              >
                <Icon
                  icon='arrow-bottom'
                  className={cn('w-5 h-5 transition-transform duration-200', isPopoverOpen && 'rotate-180')}
                />
              </Button>
            </PopoverTrigger>
            <PopoverContent className='bg-content2'>
              <div className='flex flex-col gap-2 py-2'>
                {NAV_TOPNAV.map((item) => (
                  <div key={item.label}>
                    <Link
                      href={item.href}
                      className='flex flex-row gap-2 items-center p-2'
                      title={item.title}
                      onClick={() => setIsPopoverOpen(false)}
                    >
                      <Icon icon={item.icon} className='w-4 h-4' /> {item.label}
                    </Link>
                  </div>
                ))}

                {/* Admin Link - Only visible to admin users */}
                {isAdmin && (
                  <div>
                    <Link
                      href='/dashboard'
                      className='flex flex-row gap-2 items-center p-2'
                      onClick={() => setIsPopoverOpen(false)}
                    >
                      <Icon icon='shield' className='w-4 h-4' />
                      Admin
                    </Link>
                  </div>
                )}
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </NavbarContent>
    </div>
  )
}
